import React, { useEffect, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import {
  Paper,
  Button,
  Typography,
  TextField,
  Container
} from "@material-ui/core";
import { useRequest } from "ahooks";
import SubmitButton from "@/components/commons/SubmitButton";
import useStyles from "@/styles/alarmStyle";
import { useTranslation } from "@/langs/useTranslation";
import { toast } from "@/apis/request";
import { Form, FormItem } from "@/components/Form";
import StripedTitle from "@/components/StripedTitle";
import LoadingIndicator from "@/components/commons/LoadingIndicator";
import {
  createScheduleTemplate,
  getScheduleTemplateInfo,
  updateScheduleTemplate
} from "@/apis/apiCollection";
import HasPermission from "@/components/commons/HasPermission";
import TaskCreator from "./TaskCreator";

const Creation = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const classes = useStyles();

  const [initialValues, setInitialValues] = useState({
    name: "",
    schedules: []
  });

  const detailMode = useRouteMatch({
    path: "/schedule/template/info/:id"
  });

  const editMode = useRouteMatch({
    path: "/schedule/template/edit/:id"
  });

  const match = detailMode || editMode;

  const { loading, runAsync } = useRequest(createScheduleTemplate, {
    manual: true
  });

  const { loading: detailLoading, runAsync: getDetail } = useRequest(
    async () => {
      const res = await getScheduleTemplateInfo({
        template_id: match.params.id
      });
      setInitialValues(res.data);
    },
    {
      manual: true
    }
  );

  const { loading: updateLoading, runAsync: runUpdateAsync } = useRequest(
    updateScheduleTemplate,
    {
      manual: true
    }
  );

  const handleSubmit = async values => {
    const derivedValues = {
      ...values,
      schedule_ids: values.schedules.map(item => item.id)
    };
    delete derivedValues.schedules;
    if (editMode) {
      derivedValues.template_id = editMode.params.id;
      await runUpdateAsync(derivedValues);
    } else {
      await runAsync(derivedValues);
    }
    history.goBack();
    toast.success(t({ defaultMessage: "操作成功" }));
  };

  useEffect(() => {
    if (match) {
      getDetail({ id: match.params.id });
    }
  }, []);

  return (
    <div className={classes.main}>
      <Paper elevation={0}>
        {detailLoading ? (
          <LoadingIndicator />
        ) : (
          <Form
            disabled={!!detailMode}
            initialValues={initialValues}
            onSubmit={handleSubmit}
          >
            <div className={classes.tableTop}>
              <Typography variant="h5">
                {editMode
                  ? t({ defaultMessage: "编辑排程模板" })
                  : detailMode
                  ? t({ defaultMessage: "排程模板详情" })
                  : t({ defaultMessage: "新增排程模板" })}
              </Typography>
              <div className={classes.rightAction}>
                {detailMode ? (
                  <HasPermission permission="schedule_task_policy_edit">
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={() => {
                        history.replace(
                          `/schedule/template/edit/${match.params.id}`
                        );
                      }}
                    >
                      {t({ defaultMessage: "编辑" })}
                    </Button>
                  </HasPermission>
                ) : (
                  <SubmitButton
                    color="primary"
                    variant="contained"
                    loading={loading || updateLoading}
                  >
                    {t({ defaultMessage: "确定" })}
                  </SubmitButton>
                )}
                <Button
                  variant="outlined"
                  onClick={() => {
                    history.goBack();
                  }}
                >
                  {t({ defaultMessage: "取消" })}
                </Button>
              </div>
            </div>
            <Container maxWidth="md">
              <StripedTitle>{t({ defaultMessage: "基本信息" })}</StripedTitle>
              <FormItem
                row
                required
                labelBold
                label={t({ defaultMessage: "排程模板名称" })}
                name="name"
                rules={{
                  required: true,
                  message: t({ defaultMessage: "排程模板名称不能为空" })
                }}
              >
                <TextField
                  variant="outlined"
                  size="small"
                  fullWidth
                  inputProps={{ maxLength: 100 }}
                  placeholder={t({ defaultMessage: "请填写名称" })}
                />
              </FormItem>
              <FormItem
                row
                labelBold
                required
                label={t({ defaultMessage: "配置排程任务" })}
                name="schedules"
                rules={{
                  strategy: "length",
                  message: t({ defaultMessage: "请添加排程任务" })
                }}
              >
                <TaskCreator />
              </FormItem>
            </Container>
          </Form>
        )}
      </Paper>
    </div>
  );
};

export default Creation;
